'use strict'

import $ from 'jquery'
import '../ncaa-vendor'
import MemberListTable from './memberList-datatable'

const DATATABLE_SELECTOR = '#memberListTable'

function bootstrapPage (typeId, division, state, sportCode, typeDescription) {
  sessionStorage.setItem('listType', typeId)
  sessionStorage.setItem('listDescription', typeDescription)

  new MemberListTable(DATATABLE_SELECTOR, typeId, division, state, sportCode)
}

document.addEventListener('DOMContentLoaded', function () {
  let typeId = parseInt($('#typeId').val())
  let division = $('#division').val()
  let state = $('#state').val()
  let sportCode = $('#sportCode').val()
  let typeDescription = $('#typeDescription').val()

  bootstrapPage(typeId, division, state, sportCode, typeDescription)
})



// WEBPACK FOOTER //
// ./src/js/directory/memberList-page.js